import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useAuthError = () => {
  const [showAuthError, setShowAuthError] = useState(false);
  const navigate = useNavigate();

  const handleAuthError = () => {
    setShowAuthError(true);
  };

  const handleReload = () => {
    window.location.reload();
  };

  const handleLogin = () => {
    navigate('/login');
  };

  const handleDismiss = () => {
    setShowAuthError(false);
  };

  return {
    showAuthError,
    handleAuthError,
    handleReload,
    handleLogin,
    handleDismiss,
  };
};
